module.exports = __webpack_public_path__ + "img/decider-combinator.9c5f2cc1.png";